import React from "react";
import CardImage from "../CardImage";
import { getPublishUrl } from "utilities/mediaUrl";

import { Media } from "types/qbank/media";
import { DeploymentSite } from "types/qbank/deploymentSite";

type IProps = {
    media: Media;
    deploymentSite: DeploymentSite;
    onDoubleClick: (media: any, event: React.MouseEvent<HTMLDivElement>) => void;
};


function ChildMedia({ media, deploymentSite, onDoubleClick }: IProps) {
    const handleDoubleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        onDoubleClick(media, event);
    };

    const publishUrl = getPublishUrl(deploymentSite, media.deployedFiles, NaN);

    return (
        <div onDoubleClick={handleDoubleClick} key={media.mediaId} className={"loader-image"}>
            <CardImage
                media={media}
                thumbnailSrc={publishUrl || ""}
                publishSrc={publishUrl || ""}
                alt={media.filename}
            />
        </div>)
}

export default ChildMedia;